import gql from 'graphql-tag';

export default gql`
    mutation AuthSetInitialPassword($token: String!, $password: String!) {
        auth {
            setInitialPassword(authToken: $token, password: $password) {
                ... on BasicMutationSuccess {
                    code
                }
                ... on ValidationException {
                    code
                    messages
                    details {
                        fieldName
                        messages
                    }
                }
            }
        }
    }
`;
